{
  "schemaVersion": "qec-trace-0.3",
  "engineVersion": "1.0.0",
  "pathMapVersion": "qec-path-map-0.3.0",
  "manifestationVersion": "qec-manifestation-0.2",
  "program": "אור",
  "programHash": "fnv1a32-ddb3d910",
  "seed": 5,
  "initialState": [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    5
  ],
  "events": [
    {
      "sequence": 0,
      "instructionIndex": 0,
      "letter": "א",
      "transform": "preserve-frame",
      "route": [
        "Keter",
        "Tiferet"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "KeterService",
        "TiferetScheduler"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        5
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        5
      ],
      "beforeHash": "056f79f1",
      "afterHash": "056f79f1",
      "coherence": {
        "activation": 0.447,
        "phase": 1.823,
        "coherence": 0.889
      }
    },
    {
      "sequence": 1,
      "instructionIndex": 1,
      "letter": "ו",
      "transform": "mirror-exchange",
      "route": [
        "Hod",
        "Yesod"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "HodInterface",
        "YesodBus"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        5
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        2,
        4,
        0,
        0,
        2,
        0,
        0,
        0,
        5
      ],
      "beforeHash": "056f79f1",
      "afterHash": "45ded98b",
      "coherence": {
        "activation": 0.259,
        "phase": 3.928,
        "coherence": 0.662
      }
    },
    {
      "sequence": 2,
      "instructionIndex": 2,
      "letter": "ר",
      "transform": "seed-rotation",
      "route": [
        "Yesod",
        "Malchut"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "YesodBus",
        "MalchutOutput"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        2,
        4,
        0,
        0,
        2,
        0,
        0,
        0,
        5
      ],
      "after": [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        0,
        1,
        2,
        3,
        4,
        5
      ],
      "beforeHash": "45ded98b",
      "afterHash": "bb5c59cb",
      "coherence": {
        "activation": 0.667,
        "phase": 3.511,
        "coherence": 0.933
      }
    }
  ],
  "completeTraceHash": "fnv1a32-36c70603",
  "observation": {
    "step": 3,
    "reason": "program-end",
    "stateHash": "c0615f4a",
    "traceHash": "fnv1a32-36c70603",
    "candidates": [
      {
        "id": "register-order",
        "label": "Register order",
        "stateHash": "bd615a91",
        "focusLetter": "נ",
        "confidence": 0.524,
        "rationale": "Reads the manifested registers in machine order."
      },
      {
        "id": "mirror-order",
        "label": "Mirror order",
        "stateHash": "5d0878c0",
        "focusLetter": "פ",
        "confidence": 0.986,
        "rationale": "Reads the same state through its paired-register reflection."
      },
      {
        "id": "phase-offset",
        "label": "Aleph Olam phase",
        "stateHash": "dd06f90d",
        "focusLetter": "נ",
        "confidence": 0.529,
        "rationale": "Projects the state through the shared Aleph Olam orientation."
      }
    ],
    "selectedProjection": "phase-offset",
    "snapshot": [
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      0,
      1,
      2,
      3,
      4,
      5
    ]
  }
}
